import {FC, PropsWithChildren} from 'react';
import {Outlet} from 'react-router';

import {MainHeader} from './MainHeader';
import Sidebar from '@app/layout/Sidebar';
import styled from 'styled-components';
import {theme} from '@styles/theme';
import CustomToastContainer from "@atoms/CustomToastContainer";

export const MainWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${theme.colors.basic07};
`;

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 80px);
  height: 100%;
  margin: 24px 40px 36px;
  background-color: ${theme.colors.basic08};
  border: 1px solid ${theme.colors.basic06};
  border-radius: ${theme.roundedBig};
`;

export const MainLayout: FC<PropsWithChildren> = () => {
  return (
    <MainWrapper>
      <CustomToastContainer autoClose={5000} position="bottom-center" />
      <Sidebar />
      <MainContentWrapper>
        <MainHeader />
        <ContentWrapper>
          <Outlet />
        </ContentWrapper>
      </MainContentWrapper>
    </MainWrapper>
  );
};
